import React from 'react';
import AnnualLeave from '../../../components/annualLeave/AnnualLeave/AnnualLeave';

const AnnualLeaveUser = () => {
    return (
        <AnnualLeave />
    )
}

export default AnnualLeaveUser;